import React, { useCallback, useRef } from 'react'
import MerchandiseSearchFilters, { MerchandiseFilterFacetForm } from './MerchandiseSearchFilters'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import FormModal from 'LuxKit/Modal/FormModal'

interface Props {
  userFilters: App.MerchandiseFilters
  category?: App.MerchandiseCategory
  urlFilters: App.MerchandiseFilters
  children?: React.ReactNode
}

/**
 * Simple modal wrapper for MerchandiseSearchFilters
 * All business logic lives in MerchandiseSearchFilters component
 */
function MerchandiseSearchFilterModal(props: Props) {
  const { userFilters, category, urlFilters, children } = props

  const { resolve } = useModalElementContext<App.MerchandiseFilters | null>()

  // Track the latest merged filters from SearchFilters component
  const latestMergedFiltersRef = useRef<App.MerchandiseFilters>(userFilters)

  const onFilterChange = useCallback((_formFilters: MerchandiseFilterFacetForm, mergedFilters?: App.MerchandiseFilters) => {
    // Keep track of latest merged filters
    if (mergedFilters) {
      latestMergedFiltersRef.current = mergedFilters
    }
  }, [])

  const onApplyFilters = useCallback<React.FormEventHandler<HTMLFormElement>>((e) => {
    e.preventDefault()
    // Return the latest merged filters (not raw form data)
    resolve(latestMergedFiltersRef.current)
  }, [resolve])

  const onResetFilters = useCallback(() => {
    resolve(null)
  }, [resolve])

  return <FormModal
    title="Filters"
    primaryActionText="View products"
    onSubmit={onApplyFilters}
    secondaryActionText="Reset all"
    onSecondaryActionClick={onResetFilters}
  >
    {children || <MerchandiseSearchFilters
      userFilters={userFilters}
      category={category}
      urlFilters={urlFilters}
      onChange={onFilterChange}
    />}
  </FormModal>
}

export default MerchandiseSearchFilterModal
